
































































































































































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _orderBy from 'lodash/orderBy'
import _filter from 'lodash/filter'

import AssociationDetailOverlay from '@/components/overlays/AssociationDetailOverlay.vue'
import { IAssociation } from '@/models'

@Component( {
    components: {
        'oe-association-detail-overlay': AssociationDetailOverlay
    },
    computed: mapGetters( {
        associationById: 'associationsModule/associationById',
        commentsByUserId: 'commentsModule/commentsByUserId',
        commentById: 'commentsModule/commentById',
        users: 'usersModule/users',
        currentUser: 'usersModule/currentUser',
        totalVotesByUser: 'usersModule/totalVotesByUser'
    } )
} )
export default class UsersView extends Vue {
    $refs!: {
        associationDetailOverlay: AssociationDetailOverlay;
    }
    openItem = 0
    orderFilter = 'associations'
    users!: any
    totalVotesByUser!: any
    currentUser!: any
    usersLimit = 10

    get orderedUsers() {
        const usersByLanguage = _filter( this.users, { preferredLanguage: this.$i18n.locale } )
        const usersWithoutCurrentUser = _filter( usersByLanguage, ( user ) => user.id !== this.currentUser.id )

        switch ( this.orderFilter ) {
            case 'associations':
                return _orderBy( usersWithoutCurrentUser.slice( 0, this.usersLimit ), [( o ) => o.relatedAssociations.length], ['desc'] )
            case 'votes':
                return _orderBy( usersWithoutCurrentUser.slice( 0, this.usersLimit ), [( o ) => this.totalVotesByUser( o.id )], ['desc'] )
            case 'comments':
                return _orderBy( usersWithoutCurrentUser.slice( 0, this.usersLimit ), [( o ) => o.relatedComments.length], ['desc'] )
            default:
                return _orderBy( usersWithoutCurrentUser.slice( 0, this.usersLimit ), [( o ) => o.relatedAssociations.length], ['desc'] )
        }
    }

    setOpenItem ( id: number ) {
        this.openItem === id ? this.openItem = 0 : this.openItem = id
    }

    showAssociationDetail( association: IAssociation ) {
        if ( association ) {
            this.$store.commit( 'imagesModule/setCurrentImage', association.relatedImage )
            this.$refs.associationDetailOverlay.showOverlay( association.id )
        }
    }

    loadMore() {
        this.usersLimit += 10
    }
}
